/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CarTireDtoFromJSON(json) {
    return CarTireDtoFromJSONTyped(json, false);
}
export function CarTireDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tireMakeId': !exists(json, 'tireMakeId') ? undefined : json['tireMakeId'],
        'tireMakeValue': !exists(json, 'tireMakeValue') ? undefined : json['tireMakeValue'],
        'tireDiameterId': !exists(json, 'tireDiameterId') ? undefined : json['tireDiameterId'],
        'tireDiameterValue': !exists(json, 'tireDiameterValue') ? undefined : json['tireDiameterValue'],
        'tireRatioId': !exists(json, 'tireRatioId') ? undefined : json['tireRatioId'],
        'tireRatioValue': !exists(json, 'tireRatioValue') ? undefined : json['tireRatioValue'],
        'tireWidthId': !exists(json, 'tireWidthId') ? undefined : json['tireWidthId'],
        'tireWidthValue': !exists(json, 'tireWidthValue') ? undefined : json['tireWidthValue'],
        'productionYear': !exists(json, 'productionYear') ? undefined : json['productionYear'],
    };
}
export function CarTireDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tireMakeId': value.tireMakeId,
        'tireMakeValue': value.tireMakeValue,
        'tireDiameterId': value.tireDiameterId,
        'tireDiameterValue': value.tireDiameterValue,
        'tireRatioId': value.tireRatioId,
        'tireRatioValue': value.tireRatioValue,
        'tireWidthId': value.tireWidthId,
        'tireWidthValue': value.tireWidthValue,
        'productionYear': value.productionYear,
    };
}
